<template>
  <div>
    <Pos_detail_product_data/>
  </div>
</template>

<script>
import Pos_detail_product_data
  from "@/components/adminArin/pos_system/warehouse/manage_product/Pos_detail_product_data";
export default {
  name: "PosDetailProductData",
  components: {
    Pos_detail_product_data
  }
}
</script>

<style scoped>

</style>
